import React from 'react';
import SolvedControlSubgrid from './SolvedControlSubgrid';

type ControlGridProps = {
  gridId: number;
};

const SolvedControlGrid = ({ gridId }: ControlGridProps) => {
  return (
    <div className={`controlGrid grid${gridId}`}>
      <div className="controlGridFlipper">

        <div className="controlGridContents">
          <SolvedControlSubgrid gridId={gridId} subgridId={0}/>

          <SolvedControlSubgrid gridId={gridId} subgridId={1}/>

          <SolvedControlSubgrid gridId={gridId} subgridId={3}/>

          <SolvedControlSubgrid gridId={gridId} subgridId={2}/>
        </div>

      </div>
    </div>
  );
};

export default SolvedControlGrid;